// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-header[data-v-31770bd6]{display:flex;justify-content:center;padding-top:12px;width:100%;background-color:var(--primary-color)}@media screen and (max-width:300px){.widget-header[data-v-31770bd6]{flex-direction:column}}", ""]);
// Exports
module.exports = exports;
